import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

lessRequire('modules/streams/components/table/postback-log.less');

const LogsTable = props => {
	const {rows, intl} = props;

	return (<table className="dashboard-table">
		<thead className="dashboard-table__head font-proxima-nova-semibold">
			<tr>
				<th>{intl('Время')}</th>
				<th>Url</th>
				<th>{intl('Код ответа')}</th>
				<th>{intl('Ошибка')}</th>
			</tr>
		</thead>
		<tbody className="dashboard-table__body">
			{ rows.map((row, i) => (
				<tr key={i}>
					<td className="datetime">
						<p>{moment(row.date).format('DD.MM.YYYY')}</p>
						<p>{moment(row.date).format('HH:mm:ss')}</p>
					</td>
					<td className="url"><span>{decodeURIComponent(row.url)}</span></td>
					<td className="code"><span>{row.status != 0 ? row.status : intl('Сервер не найден')}</span></td>
					<td className="code"><span>{intl(row.error_stack)}</span></td>
				</tr>
			)) }
			{ props.isShowMoreVisible && <ShowMoreRows showMore={props.showMore} intl={intl} /> }
		</tbody>
	</table>);
};

const ShowMoreRows = ({ showMore, intl }) => (
	<tr className="show-more">
		<th colSpan="16">
			<a href="#" className="icon-show-more font-proxima-nova-regular" onClick={ e => {
				e.preventDefault();
				showMore();
			}}>
				<span>
					{intl('Показать ещё')}
				</span>
			</a>
		</th>
	</tr>
);

LogsTable.propTypes = {
	rows: PropTypes.array,
	isShowMoreVisible: PropTypes.bool,
	showMore: PropTypes.func,
	intl: PropTypes.func
};

ShowMoreRows.propTypes = {
	showMore: PropTypes.func,
	intl: PropTypes.func
};

export default LogsTable;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/table/postback-log.js